// Adapted from https://github.com/getsentry/sentry-rrweb/blob/master/src/index.ts
// to support lazy loading & full set of rrweb options
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as Sentry from "@sentry/browser";
var SentryRRWeb = /*#__PURE__*/ function() {
    "use strict";
    function SentryRRWeb() {
        var _this = this;
        var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, SentryRRWeb);
        var _param_checkoutEveryNms = _param.checkoutEveryNms, checkoutEveryNms = _param_checkoutEveryNms === void 0 ? 5 * 60 * 1000 : _param_checkoutEveryNms, _param_maskAllInputs = _param.maskAllInputs, maskAllInputs = _param_maskAllInputs === void 0 ? true : _param_maskAllInputs, recordOptions = _object_without_properties(_param, [
            "checkoutEveryNms",
            "maskAllInputs"
        ]);
        _define_property(this, "name", SentryRRWeb.id);
        _define_property(this, "events", []);
        _define_property(this, "recordOptions", void 0);
        // default checkout time of 5 minutes
        this.recordOptions = _object_spread({
            checkoutEveryNms: checkoutEveryNms,
            maskAllInputs: maskAllInputs
        }, recordOptions);
        this.events = [];
        // Don't load client dependency rrweb if server rendering
        if (typeof window !== 'undefined') {
            void import("rrweb").then(function(rrweb) {
                rrweb.record(_object_spread_props(_object_spread({}, _this.recordOptions), {
                    emit: function(event, isCheckout) {
                        if (isCheckout) {
                            _this.events = [
                                event
                            ];
                        } else {
                            _this.events.push(event);
                        }
                    }
                }));
            });
        }
    }
    _create_class(SentryRRWeb, [
        {
            key: "setupOnce",
            value: function setupOnce() {
                var _this = this;
                Sentry.addEventProcessor(function(event) {
                    var _this_processEvent;
                    return event ? (_this_processEvent = _this.processEvent(event)) !== null && _this_processEvent !== void 0 ? _this_processEvent : null : null;
                });
            }
        },
        {
            key: "attachmentUrlFromDsn",
            value: function attachmentUrlFromDsn(dsn, eventId) {
                var host = dsn.host, path = dsn.path, projectId = dsn.projectId, port = dsn.port, protocol = dsn.protocol, publicKey = dsn.publicKey;
                return "".concat(protocol, "://").concat(host).concat(port !== '' ? ":".concat(port) : '').concat(path !== '' ? "/".concat(path) : '', "/api/").concat(projectId, "/events/").concat(eventId, "/attachments/?sentry_key=").concat(publicKey, "&sentry_version=7&sentry_client=rrweb");
            }
        },
        {
            key: "processEvent",
            value: function processEvent(event) {
                Sentry.getCurrentScope().addAttachment({
                    filename: 'rrweb.json',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        events: this.events
                    })
                });
                return event;
            }
        }
    ]);
    return SentryRRWeb;
}();
_define_property(SentryRRWeb, "id", 'SentryRRWeb');
export { SentryRRWeb as default };
